// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__8vzsh","header":"default_header__AN5Ty","content":"default_content__-y1LQ"};